import React, { useEffect, useState } from 'react';
import { Button } from "@mui/material";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { RiUserAddFill } from "react-icons/ri";
import { Link } from 'react-router-dom';
import FilledPattern from '../../components/filled-pattern/filled-pattern';
import StrokePattern from '../../components/stroke-pattern/stroke-pattern';
import { MdEditSquare } from "react-icons/md";
import { IoChatbox } from "react-icons/io5";

const HomeOrganisation = () => {


    const verbs = ['streamlined', 'organised', 'managed'];
    const [count, setCount] = useState(0);


    useEffect(()=>{
        setTimeout(()=>{
            setCount(count >= verbs.length - 1 ? 0 : count + 1);
        }, 1000);
    }, [count]);


    return (
        <div>

            <div className="middleSection">
                <div className="leftSection initially-hidden animated slideUpAnimation">
                    <StrokePattern styles={{ position: 'absolute', width: '100px', left: '-100px' }} />

                    <h1 className="bannerHeading primary-text-colour">
                        <span className="tertiary-dark-text">Nursing <span className="primary-text"> Placements</span><span className="tertiary-text" style={{backgroundColor: '#97feed'}}> {verbs[count]}</span></span>
                    </h1>

                    <p className="subtitle1">Streamline communication between
                        Education Providers, manage placement
                        capacity, organise staffing and produce
                        finance reporting.
                    </p>
                    {/* <p className="body">
            Have you engaged coaches and consultants to help scale your business but found the results to be disappointing?
            </p> */}

                    <div className="buttonContainer">
                        {/* <Link to="/business-assessment">
                            <Button className="btn btn-primary callToAction subtitle2" variant="contained" endIcon={<MdEditSquare />}>
                                Assess Your Business
                            </Button>
                        </Link> */}
                        <Link to="https://calendar.app.google/jDHDYVpEYcaE3asL7" target='blank'>
                            <Button className="btn btn-primary callToAction subtitle2" variant="contained" endIcon={<IoChatbox />}>
                                Let's Chat
                            </Button>
                        </Link>
                    </div>
                </div>
                <div className="rightSection initially-hidden animated slideLeftAnimation">
                    

                    <img className="mockup" src='/images/mackbook-mockup.webp'>
                    </img>
                    <svg id="sw-js-blob-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" version="1.1">
                                            <defs>          
                                                               <linearGradient id="sw-gradient" x1="0" x2="1" y1="1" y2="0">
                                                                                            <stop id="stop1" stop-color="#35a29f" offset="0%"></stop>           
                                                                                            <stop id="stop2" stop-color="#071952" offset="100%"></stop>                     
                                                              </linearGradient>                    
                                            </defs>
                                            <path fill="url(#sw-gradient)"
                                             d="M25,-29.8C29.9,-25.8,29.6,-15.5,30.7,-5.8C31.9,3.8,34.7,12.7,31.4,18C28.2,23.3,18.9,25,10.1,28.6C1.2,32.2,-7.2,37.7,-16,37.4C-24.8,37,-33.8,30.9,-34.6,23.1C-35.4,15.3,-28,5.8,-24.7,-2.9C-21.4,-11.6,-22.3,-19.6,-18.8,-23.9C-15.4,-28.2,-7.7,-28.9,1.2,-30.3C10.1,-31.8,20.2,-33.9,25,-29.8Z" 
                                             width="100%" 
                                             height="100%" 
                                             transform="translate(50 50)" 
                                             style={{transition: '0.3s'}} 
                                             stroke-width="0">

                                             </path>
                                  </svg>

{/*                     
                    <video src="/videos/Kzen8 Global Partner Network 2024.mp4" autoPlay="true" playsInline="true" muted="false" controls alt="Kzen8 - Partner Expert">

                        <track default kind="captions" srclang="en" src="/subtitles/captions from Global Partner Network video.vtt" />


                    </video> */}
                    {/* <FilledPattern styles={{ position: 'absolute', top: '-100px', right: '-100px', zIndex: -1, width: '15vw', maxWidth: 'unset' }} /> */}
                    <StrokePattern styles={{ position: 'absolute', width: '200px', left: '-100px' }} />
                    <StrokePattern styles={{ position: 'absolute', width: '125px', top: 0, right: '-100px' }} />

                </div>
            </div>

        </div>
    );
}

export default HomeOrganisation;
